export enum LabelFormatType {
	Zpl = 'Zpl',
	Sld = 'Sld',
}
